<template>
  <div>
    <navbar
      v-if="show"
      class="no-print"
      @toggle-sidebar="toggleSidebar = !toggleSidebar"
      :loggedInUserData="loggedInUserData"
    ></navbar>
    <div class="page-container">
      <div class="page-content">
        <sidebar
          v-if="toggleSidebar"
          class="no-print"
          :loggedInUserData="loggedInUserData"
          :orderCounts="orderCounts"
        ></sidebar>

        <div class="content-wrapper">
          <div class="content pb-0">
            <div class="panel panel-flat">
              <router-view @clicked="onClickChild"></router-view>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sidebar from './sidebar'
import navbar from './navbar'
import axios from 'axios'

export default {
  components: {
    sidebar: sidebar,
    navbar: navbar
  },

  created() {
    this.getUser()
    this.getOrderCounts()
  },

  mounted() {
    this.countsInterval = setInterval(this.getOrderCounts, 60000)
    document.addEventListener('visibilitychange', this.onVisibilityChange)
  },

  beforeDestroy() {
    if (this.countsInterval) {
      clearInterval(this.countsInterval)
    }
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
  },

  data() {
    return {
      loggedInUserData: {},
      orderCounts: {},
      countsInterval: null,
      show: false,
      toggleSidebar: true
    }
  },

  methods: {
    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
      this.show = true
    },

    getUser() {
      this.show = false
      let token = localStorage.getItem('access_token')
      axios
        .get('api/me', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          localStorage.setItem('user_data', JSON.stringify(response.data))
        })
        .then(() => {
          this.getLoggedInUser()
        })
    },

    getOrderCounts() {
      // Background tabs don't need live badge counts; they refresh on return
      if (document.hidden) {
        return
      }
      let token = localStorage.getItem('access_token')
      axios
        .get('api/order-status-counts', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.orderCounts = response.data
        })
        .catch(() => {})
    },

    onVisibilityChange() {
      if (!document.hidden) {
        this.getOrderCounts()
      }
    },

    onClickChild() {
      this.getUser()
      this.getOrderCounts()
    },
  },
}
</script>

<style>
.panel-flat {
  width: 100%;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/pageContainer.vue